module.exports = __webpack_public_path__ + "img/before.655384ee.jpg";